module.exports = __webpack_public_path__ + "img/default.7a64166a.png";